const DEFAULT_CONFIG = {
	//接口地址
	API_URL: 'https://admin.rsx.org.cn',
}

export default DEFAULT_CONFIG
